import React from 'react'
import _ from 'lodash';
import AgTechLoadingSurface from '@agtech/web/components/Pages/Loading/AgTechLoadingSurface';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import SaleWorkspace from './areas/sales/SaleWorkspace';
import { useCurrentSale } from '@sales/data/sales/SaleDataStore';
import SaleDialog from './areas/sales/dialogs/SaleDialog';

const SalesAppHomePage = () => {
    const currentSale = useCurrentSale();

    return (
        <AgTechLoadingSurface refreshWhenChanged={currentSale.id + ''} text="Loading sale...">
            { currentSale && currentSale.id !== 0 ? (
                <SaleWorkspace sale={currentSale} /> 
            ) : (
                <AgTechNoRecordsPage
                    message="There are no sales in the system right now."
                    action={{
                        prompt: 'To create one, please click the button below',
                        button: () => <SaleDialog.Button /> 
                    }}
                />
            )}
        </AgTechLoadingSurface>
    )
}

export default SalesAppHomePage